import { useEffect, useState } from 'react';
import { MAX_PENDING_ACTION_DURATION_MS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/constants';

/**
 * Holds the roleId whose signing should auto-open once its signer is ready.
 * Clears after the window so readiness that never arrives can't auto-open the
 * flow on a later unrelated refetch. Expiry pauses while the assignment is
 * still settling (`isSignerUpdatePending`), which already bounds that window.
 */
export const usePendingClaimSign = (isSignerUpdatePending: boolean) => {
	const [pendingClaimSignRoleId, setPendingClaimSignRoleId] = useState<string | null>(null);

	useEffect(() => {
		if (!pendingClaimSignRoleId || isSignerUpdatePending) {
			return undefined;
		}
		const timeoutId = window.setTimeout(() => {
			setPendingClaimSignRoleId(null);
		}, MAX_PENDING_ACTION_DURATION_MS);
		return () => window.clearTimeout(timeoutId);
	}, [pendingClaimSignRoleId, isSignerUpdatePending]);

	return [pendingClaimSignRoleId, setPendingClaimSignRoleId] as const;
};
